import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment.js';
import { trackTikTokEvent, trackPostHog } from '../utils/tracking.js';

export const trackSubstitution = (playerOut, playerIn, minute, gameId) => {
  const eventData = {
    player_out: playerOut,
    player_in: playerIn,
    minute: minute,
    game_id: gameId,
    ...getEnvironmentData()
  };

  track('substitution', eventData);
  
  const tiktokEvent = {
    contents: [
      {
        content_name: 'substitution',
        content_type: 'product',
        content_id: gameId
      }
    ]
  };
  trackTikTokEvent('CustomizeProduct', tiktokEvent);

  trackPostHog('substitution_made', eventData);
};

export const trackSubstitutionUndo = (playerOut, playerIn, minute, gameId) => {
  const eventData = {
    player_out: playerOut,
    player_in: playerIn,
    minute: minute,
    game_id: gameId,
    ...getEnvironmentData()
  };

  track('substitution_undo', eventData);
  
  const tiktokEvent = {
    contents: [
      {
        content_name: 'substitution_undo',
        content_type: 'product',
        content_id: gameId
      }
    ]
  };
  trackTikTokEvent('RemoveFromCart', tiktokEvent);

  trackPostHog('substitution_undone', eventData);
}; 